import type { GlobalApiPaymentDetails } from '@data/global-api-payments';
import { CURRENT_SERVICE_TYPE } from '@utility/checkout-utils';

import { getScaHeaders, SCA_API_ENDPOINTS } from '../../global.constants';
import { useScaMutation } from '../useScaMutation';

export const useCancelPayment = ({
  paymentId,
  authToken,
}: {
  paymentId: string;
  authToken: string;
}) => {
  return useScaMutation<GlobalApiPaymentDetails, never>({
    url: SCA_API_ENDPOINTS.postCancelPayment(paymentId, CURRENT_SERVICE_TYPE),
    method: 'POST',
    headers: getScaHeaders({ authToken }),
  });
};
